import { useEffect, useState, type RefObject } from 'react';

export interface ContainerSize {
  w: number;
  h: number;
}

export function useContainerSize(ref: RefObject<HTMLElement | null>): ContainerSize {
  const [size, setSize] = useState<ContainerSize>({ w: 0, h: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      const w = el.clientWidth;
      const h = el.clientHeight;
      setSize((prev) => (prev.w === w && prev.h === h ? prev : { w, h }));
    };

    const ro = new ResizeObserver(update);
    ro.observe(el);
    update();

    return () => ro.disconnect();
  }, [ref]);

  return size;
}

export function useContainerWidth(ref: RefObject<HTMLElement | null>): number {
  const { w } = useContainerSize(ref);
  return w;
}
